// extracted by mini-css-extract-plugin
export default {"root":"SectionTabs_root__+3VQm","section":"SectionTabs_section__2QHw-","tabs":"SectionTabs_tabs__ZTp7v","tab":"SectionTabs_tab__hiI1M","tabContent":"SectionTabs_tabContent__UW5IM"};